import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import AdresseAutocomplete from "./AdresseAutocomplete";
import "./annonce.css";

const PROFESSION_LIST = [
  "Carrosserie",
  "Detailling",
  "Mécanique",
  "Nettoyage automobile",
  "Pare-brise",
  "Pneu",
  "Plombier",
  "Remorquage",
  "Serrurier",
  "Serrurier automobile",
];

/* ===== Bibliothèque d’activités par profession (sans durée ni prix) =====
   Les libellés issus des annonces validées sont fusionnés via /api/activity-catalog/:profession */
const ACTIVITY_LIBRARY = {
  Carrosserie: [
    { name: "Débosselage sans peinture" },
    { name: "Peinture partielle (élément)" },
    { name: "Remplacement pare-chocs" },
    { name: "Redressage aile" },
    { name: "Réparation pare-chocs (fissures)" },
    { name: "Peinture jante" },
    { name: "Remplacement rétroviseur" },
  ],
  Detailling: [
    { name: "Polish complet" },
    { name: "Rénovation optiques" },
    { name: "Traitement céramique carrosserie" },
    { name: "Nettoyage intérieur complet" },
    { name: "Detailing intérieur approfondi" },
    { name: "Polissage 1 étape" },
    { name: "Polissage 2 étapes (correction)" },
    { name: "Céramique vitres" },
    { name: "Lustrage carrosserie" },
    { name: "Protection PPF (zone)" },
    { name: "Céramique jantes" },
    { name: "Soin cuir / alcantara" },
  ],
  Mécanique: [
    { name: "Vidange + filtre" },
    { name: "Révision constructeur" },
    { name: "Révision complète (filtres + niveaux)" },
    { name: "Freinage (plaquettes + disques)" },
    { name: "Courroie de distribution" },
    { name: "Kit distribution + pompe à eau" },
    { name: "Diagnostic valise" },
    { name: "Diagnostic électronique" },
    { name: "Recherche de panne" },
    { name: "Changement d’embrayage" },
    { name: "Remplacement embrayage + volant moteur" },
    { name: "Préparation contrôle technique" },
    { name: "Remplacement amortisseurs" },
    { name: "Géométrie / parallélisme" },
    { name: "Vidange boîte automatique" },
    { name: "Nettoyage injecteurs" },
    { name: "Remplacement batterie" },
    { name: "Recharge climatisation" },
    { name: "Remplacement courroie accessoires" },
  ],
  "Nettoyage automobile": [
    { name: "Lavage extérieur" },
    { name: "Lavage extérieur + séchage" },
    { name: "Intérieur complet" },
    { name: "Nettoyage intérieur premium" },
    { name: "Detailing intérieur" },
    { name: "Shampoing sièges / moquettes" },
    { name: "Nettoyage baie moteur" },
    { name: "Polissage 1 étape" },
    { name: "Polissage 2 étapes" },
    { name: "Traitement cuir" },
    { name: "Désodorisation / ozone" },
    { name: "Lavage sans eau" },
    { name: "Décontamination fer" },
    { name: "Céramique vitres" },
  ],
  "Pare-brise": [
    { name: "Remplacement pare-brise" },
    { name: "Réparation impact" },
    { name: "Remplacement balais d’essuie-glace" },
    { name: "Réparation fissure (résine)" },
    { name: "Remplacement joint pare-brise" },
  ],
  Pneu: [
    { name: "Montage + équilibrage (2 pneus)" },
    { name: "Montage + équilibrage (4 pneus)" },
    { name: "Permutation pneus" },
    { name: "Réparation crevaison" },
    { name: "Géométrie / parallélisme" },
    { name: "Permutation + équilibrage" },
  ],
  Plombier: [
    { name: "Dépannage fuite" },
    { name: "Débouchage évier" },
    { name: "Installation chauffe-eau" },
    { name: "Remplacement robinet" },
    { name: "Désembouage circuit" },
  ],
  Remorquage: [
    { name: "Dépannage sur place" },
    { name: "Remorquage courte distance (<10km)" },
    { name: "Remorquage longue distance" },
  ],
  Serrurier: [
    { name: "Ouverture porte claquée" },
    { name: "Remplacement cylindre" },
    { name: "Pose serrure multipoints" },
    { name: "Blindage de porte" },
  ],
  "Serrurier automobile": [
    { name: "Ouverture véhicule" },
    { name: "Reprogrammation clé" },
    { name: "Extraction clé cassée" },
    { name: "Remplacement barillet" },
  ],
};

/* ===== API BASE (prod = même domaine ; sinon ENV) ===== */
const RAW =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  "";
const API_BASE = RAW
  ? RAW.replace(/\/+$/, "").replace(/\/api$/i, "")
  : (typeof window !== "undefined" && window.location.origin) || "";

// ------- POPUP VÉRIF TOUT EN HAUT --------
const VerifyPhonePopup = ({
  visible,
  phoneNumber,
  onCancel,
  onValidate,
  onResend,
  loading,
  error,
}) => {
  const [code, setCode] = useState("");
  useEffect(() => {
    setCode("");
  }, [visible]);
  if (!visible) return null;
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 9999,
        left: 0,
        top: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(30,20,15,0.17)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          minWidth: 360,
          background: "#fff7f2",
          borderRadius: 22,
          boxShadow: "0 6px 32px #0002",
          padding: "32px 32px 24px 32px",
          position: "relative",
          maxWidth: "95vw",
        }}
      >
        <button
          style={{
            position: "absolute",
            top: 18,
            right: 22,
            border: "none",
            background: "none",
            fontSize: 26,
            cursor: "pointer",
            color: "#b26a57",
          }}
          onClick={onCancel}
          aria-label="Fermer"
        >
          ×
        </button>
        <h2 style={{ color: "#7e5e47", marginBottom: 10 }}>
          Vérification du numéro
        </h2>
        <p style={{ marginBottom: 16, color: "#432c1b" }}>
          Un code de vérification a été envoyé au numéro
          <br />
          <strong style={{ letterSpacing: 1, color: "#7e5e47" }}>
            {phoneNumber}
          </strong>
        </p>
        <input
          style={{
            width: "100%",
            borderRadius: 10,
            border: "1.5px solid #c7b09b",
            fontSize: 20,
            padding: "9px 0 9px 10px",
            marginBottom: 16,
            textAlign: "center",
            letterSpacing: 3,
            outline: "none",
          }}
          type="text"
          inputMode="numeric"
          maxLength={6}
          placeholder="Code à 6 chiffres"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
        />
        {error && (
          <div style={{ color: "#c81b1b", fontSize: 15, marginBottom: 8 }}>
            {error}
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "center", gap: 22 }}>
          <button
            style={{
              padding: "9px 32px",
              borderRadius: 16,
              fontWeight: 600,
              background: "linear-gradient(90deg,#b26a57 60%,#d1876a)",
              color: "#fff",
              border: "none",
              fontSize: 18,
            }}
            onClick={() => onValidate(code)}
            disabled={loading || code.length !== 6}
          >
            Valider
          </button>
          <button
            style={{
              padding: "9px 32px",
              borderRadius: 16,
              fontWeight: 600,
              background: "linear-gradient(90deg,#eee 70%,#fff)",
              color: "#b26a57",
              border: "none",
              fontSize: 18,
            }}
            onClick={onCancel}
            disabled={loading}
          >
            Annuler
          </button>
        </div>
        <div style={{ textAlign: "center", marginTop: 18 }}>
          <button
            style={{
              border: "none",
              background: "none",
              color: "#7e5e47",
              fontSize: 15,
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={onResend}
            disabled={loading}
            type="button"
          >
            Renvoyer un nouveau code
          </button>
        </div>
      </div>
    </div>
  );
};

// Génère les créneaux pour un profil
function generateSlotsForProfil(profil) {
  if (!profil.workingHours || profil.workingHours.length === 0) return [];

  // Durée max des activités (fallback à 60 min)
  let maxDurationMinutes = 60;
  if (profil.activities && profil.activities.length > 0) {
    const durations = profil.activities
      .map((a) => {
        const h = parseInt(a.durationHours, 10) || 0;
        const m = parseInt(a.durationMinutes, 10) || 0;
        const total = h * 60 + m;
        return total;
      })
      .filter((total) => total > 0);

    if (durations.length === 0) return [];
    maxDurationMinutes = Math.max(...durations);
  }

  const slots = [];
  const today = new Date();
  const daysToGenerate = 7;
  const days = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
  ];

  for (let i = 0; i < daysToGenerate; i++) {
    const currentDate = new Date(today);
    currentDate.setDate(today.getDate() + i);

    const dayName =
      days[currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1];

    const dayWorking = profil.workingHours.find(
      (d) => d.day === dayName && d.isOpen
    );
    if (!dayWorking || !Array.isArray(dayWorking.slots)) continue;

    for (const slot of dayWorking.slots) {
      const [startH, startM] = (slot.start || "00:00").split(":").map(Number);
      const [endH, endM] = (slot.end || "00:00").split(":").map(Number);

      let slotTime = new Date(currentDate);
      slotTime.setHours(startH, startM, 0, 0);

      const endTime = new Date(currentDate);
      endTime.setHours(endH, endM, 0, 0);

      while (
        slotTime.getTime() + maxDurationMinutes * 60000 <= endTime.getTime()
      ) {
        slots.push(new Date(slotTime));
        slotTime = new Date(slotTime.getTime() + maxDurationMinutes * 60000);
      }
    }
  }

  return slots;
}

// helpers
const capitalizeFirst = (s) =>
  s && s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;

// style erreur (bordure rouge)
const errStyle = (hasError) =>
  hasError
    ? {
        borderColor: "#e11d48",
        boxShadow: "0 0 0 3px rgba(225,29,72,.12)",
      }
    : {};

const smallErr = (msg) =>
  msg ? (
    <div style={{ color: "#e11d48", fontSize: 13, marginTop: 6 }}>{msg}</div>
  ) : null;

const AnnonceForm = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const annonceId = searchParams.get("id");

  const days = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
  ];

  const [formData, setFormData] = useState({
    companyName: "",
    description: "",
    address: "",
    postalCode: "",
    city: "",
    numberPhone: "",
  });
  const [profils, setProfils] = useState([]);
  const [image, setImage] = useState(null);
  const [existingImageName, setExistingImageName] = useState(null);
  const [coordinates, setCoordinates] = useState(null);
  const [statut, setStatut] = useState("");
  const [commentaireAdmin, setCommentaireAdmin] = useState("");
  const navigate = useNavigate();


  const [errors, setErrors] = useState({
    fields: {},
    profils: {}, // { [idx]: { name, profession, activitiesEmpty, activities: { [aIdx]: {name, durationHours, durationMinutes, price} } } }
    meta: {},
  });

  // Popup SMS
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [smsLoading, setSmsLoading] = useState(false);
  const [smsError, setSmsError] = useState("");
  const [pendingPhone, setPendingPhone] = useState("");
  const [pendingData, setPendingData] = useState(null);

  /** Suggestions catalogue (pros précédents) par profession, fusionnées avec ACTIVITY_LIBRARY */
  const [catalogByProfession, setCatalogByProfession] = useState({});

  const mergeActivityLibrary = (profession) => {
    const preset = ACTIVITY_LIBRARY[profession] || [];
    const fromApi = catalogByProfession[profession]?.items || [];
    const seen = new Set();
    const out = [];
    for (const a of [...preset, ...fromApi]) {
      const name = (a.name || "").trim();
      if (!name) continue;
      const k = name.toLowerCase();
      if (seen.has(k)) continue;
      seen.add(k);
      out.push({ name });
    }
    return out;
  };

  const fetchActivityCatalog = (profession) => {
    if (!profession || !API_BASE) return;
    fetch(`${API_BASE}/api/activity-catalog/${encodeURIComponent(profession)}`, {
      credentials: "include",
    })
      .then((r) => (r.ok ? r.json() : { activities: [] }))
      .then((data) => {
        const items = (data.activities || []).map((x) => ({ name: x.name }));
        setCatalogByProfession((prev) => ({
          ...prev,
          [profession]: { loading: false, items },
        }));
      })
      .catch(() => {
        setCatalogByProfession((prev) => ({
          ...prev,
          [profession]: { loading: false, items: [] },
        }));
      });
  };

  // Abonnement / profils
  const abonnement = localStorage.getItem("abonnement") || "basic";
  const maxProfils = abonnement === "premium" ? 5 : 1;

  useEffect(() => {
    if (!annonceId) return;

    const fetchAnnonce = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/annonces/${annonceId}`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Annonce non trouvée");
        const data = await res.json();

        // Migration douce des workingHours → format slots
        const migratedProfils = (data.profils || []).map((p) => {
          const wh = Array.isArray(p.workingHours)
            ? p.workingHours.map((d) => {
                if (Array.isArray(d.slots)) return d;
                return {
                  day: d.day,
                  isOpen: d.isOpen ?? true,
                  slots: [{ start: d.start || "08:00", end: d.end || "18:00" }],
                };
              })
            : days.map((day) => ({
                day,
                isOpen: true,
                slots: [
                  { start: "08:00", end: "12:00" },
                  { start: "13:30", end: "18:00" },
                ],
              }));
          return { ...p, workingHours: wh };
        });

        setFormData({
          companyName: data.nameCompany || "",
          description: data.description || "",
          address: data.adresCompany || "",
          postalCode: data.postalCode || "",
          city: data.city || "",
          numberPhone: data.phoneNumber || "",
        });
        setProfils(migratedProfils);
        migratedProfils.forEach((p) => {
          if (p.profession) fetchActivityCatalog(p.profession);
        });
        setCoordinates(data.coordinates || null);
        if (data.image) setExistingImageName(data.image);
        setStatut(data.statut || "");
        setCommentaireAdmin(data.commentaireAdmin || "");
      } catch (err) {
        console.error("Erreur chargement annonce :", err);
        alert("Erreur lors du chargement de l'annonce.");
      }
    };

    fetchAnnonce();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [annonceId]);

  const handleImageChange = (e) => setImage(e.target.files[0]);
  const handleAddressChange = (address) =>
    setFormData((prev) => ({ ...prev, address }));
  const handleAddressSelect = (address) => {
    setFormData((prev) => ({ ...prev, address }));
    if (window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results && results[0]) {
          const location = results[0].geometry.location;
          setCoordinates([location.lng(), location.lat()]);
          let city = "";
          let postalCode = "";
          results[0].address_components.forEach((comp) => {
            if (comp.types.includes("locality")) city = comp.long_name;
            if (comp.types.includes("postal_code")) postalCode = comp.long_name;
          });
          setFormData((prev) => ({
            ...prev,
            address,
            city: city || prev.city,
            postalCode: postalCode || prev.postalCode,
          }));
        }
      });
    }
  };

  // Profils
  const handleAddProfil = () => {
    setProfils([
      ...profils,
      {
        name: "",
        profession: "",
        activities: [
          {
            name: "",
            durationHours: 0,
            durationMinutes: 0,
            price: "",
          },
        ],
        workingHours: days.map((day) => ([
          { day, isOpen: true, slots: [{ start: "08:00", end: "12:00" }, { start: "13:30", end: "18:00" }] }
        ]).flat()[0]),
        slots: [],
      },
    ]);
  };

  const handleDeleteProfil = (idx) =>
    setProfils(profils.filter((_, i) => i !== idx));
  const handleProfilFieldChange = (idx, field, value) => {
    const updated = [...profils];
    updated[idx][field] = value;
    setProfils(updated);
  };
  const handleProfilProfessionChange = (idx, value) => {
    const updated = [...profils];
    updated[idx].profession = value;
    setProfils(updated);
    if (value) fetchActivityCatalog(value);
  };

  // Ajout depuis bibliothèque (sélecteur par profil)
  const handleAddActivityFromLibrary = (profilIdx, libKey) => {
    if (!libKey) return;
    const lib = mergeActivityLibrary(profils[profilIdx].profession);
    const item = lib.find((x) => x.name === libKey);
    if (!item) return;
    const updated = [...profils];
    updated[profilIdx].activities.push({
      name: item.name,
      durationHours: 0,
      durationMinutes: 0,
      price: "",
    });
    setProfils(updated);
  };

  const handleProfilActivityChange = (profilIdx, actIdx, field, value) => {
    const updated = [...profils];
    if (field === "name") {
      const v = capitalizeFirst(value);
      updated[profilIdx].activities[actIdx].name = v;

      const lib = mergeActivityLibrary(updated[profilIdx].profession);
      const match = lib.find(
        (x) => x.name.toLowerCase() === v.trim().toLowerCase()
      );
      if (match) {
        updated[profilIdx].activities[actIdx].durationHours = 0;
        updated[profilIdx].activities[actIdx].durationMinutes = 0;
      }
    } else if (field === "durationHours" || field === "durationMinutes") {
      updated[profilIdx].activities[actIdx][field] = parseInt(value, 10) || 0;
    } else if (field === "price") {
      updated[profilIdx].activities[actIdx].price =
        value === "" ? "" : Number(value);
    } else {
      updated[profilIdx].activities[actIdx][field] = value;
    }
    setProfils(updated);
  };

  const handleProfilAddActivity = (profilIdx) => {
    const updated = [...profils];
    updated[profilIdx].activities.push({
      name: "",
      durationHours: 0,
      durationMinutes: 0,
      price: "",
    });
    setProfils(updated);
  };
  const handleProfilDeleteActivity = (profilIdx, actIdx) => {
    const updated = [...profils];
    updated[profilIdx].activities = updated[profilIdx].activities.filter(
      (_, i) => i !== actIdx
    );
    setProfils(updated);
  };

  // Ouvert/Fermé
  const handleProfilWorkingHourChange = (profilIdx, dayIdx, field, value) => {
    const updated = [...profils];
    updated[profilIdx].workingHours[dayIdx][field] =
      field === "isOpen" ? value === "true" : value;
    setProfils(updated);
  };

  // Slots (plages horaires)
  const handleSlotChange = (profilIdx, dayIdx, slotIdx, key, val) => {
    const updated = [...profils];
    updated[profilIdx].workingHours[dayIdx].slots[slotIdx][key] = val;
    setProfils(updated);
  };
  const handleAddSlot = (profilIdx, dayIdx) => {
    const updated = [...profils];
    updated[profilIdx].workingHours[dayIdx].slots.push({
      start: "12:00",
      end: "14:00",
    });
    setProfils(updated);
  };
  const handleDeleteSlot = (profilIdx, dayIdx, slotIdx) => {
    const updated = [...profils];
    updated[profilIdx].workingHours[dayIdx].slots =
      updated[profilIdx].workingHours[dayIdx].slots.filter(
        (_, i) => i !== slotIdx
      );
    setProfils(updated);
  };

  const getGeneratedSlots = (profil) => {
    const slotsDates = generateSlotsForProfil(profil);
    return slotsDates.map((date) => date.toLocaleString());
  };

  // ===== Validation détaillée (corrigée) =====
  const validateAll = () => {
    const newErrors = { fields: {}, profils: {}, meta: {} };
    let firstMsg = null;

    const setFirst = (msg) => {
      if (!firstMsg) firstMsg = msg;
    };

    // Champs globaux
    if (!formData.companyName) {
      newErrors.fields.companyName = "Champ requis";
      setFirst("Nom d’entreprise manquant.");
    }
    if (!formData.description) {
      newErrors.fields.description = "Champ requis";
      setFirst("Description manquante.");
    }
    if (!formData.address) {
      newErrors.fields.address = "Champ requis";
      setFirst("Adresse manquante.");
    }
    if (!formData.postalCode) {
      newErrors.fields.postalCode = "Champ requis";
      setFirst("Code postal manquant.");
    }
    if (!formData.numberPhone) {
      newErrors.fields.numberPhone = "Champ requis";
      setFirst("Numéro de téléphone manquant.");
    }

    if (profils.length === 0) {
      newErrors.meta.noProfil = "Ajoutez au moins un profil.";
      setFirst("Ajoutez au moins un profil.");
    }

    profils.forEach((p, i) => {
      let anyPErr = false;
      const pErr = { activities: {} };

      if (!p.name) {
        pErr.name = "Champ requis";
        setFirst(`Profil ${i + 1} : nom du profil manquant.`);
        anyPErr = true;
      }
      if (!p.profession) {
        pErr.profession = "Champ requis";
        setFirst(`Profil ${i + 1} : profession manquante.`);
        anyPErr = true;
      }
      if (!p.activities || p.activities.length === 0) {
        pErr.activitiesEmpty = "Ajoutez au moins une activité.";
        setFirst(`Profil ${i + 1} : ajoutez au moins une activité.`);
        anyPErr = true;
      }

      (p.activities || []).forEach((a, j) => {
        let anyAErr = false;
        const aErr = {};

        if (!a.name) {
          aErr.name = "Champ requis";
          setFirst(`Profil ${i + 1} • Activité ${j + 1} : nom d’activité manquant.`);
          anyAErr = true;
        }
        if (Number.isNaN(Number(a.durationHours)) || Number(a.durationHours) < 0) {
          aErr.durationHours = "Valeur invalide";
          setFirst(`Profil ${i + 1} • Activité ${j + 1} : heures invalides.`);
          anyAErr = true;
        }
        if (
          Number.isNaN(Number(a.durationMinutes)) ||
          Number(a.durationMinutes) < 0 ||
          Number(a.durationMinutes) > 59
        ) {
          aErr.durationMinutes = "0 à 59";
          setFirst(
            `Profil ${i + 1} • Activité ${j + 1} : minutes invalides (0–59).`
          );
          anyAErr = true;
        }
        if (
          a.price === "" ||
          Number.isNaN(Number(a.price)) ||
          Number(a.price) < 0
        ) {
          aErr.price = "Prix requis (nombre ≥ 0)";
          setFirst(`Profil ${i + 1} • Activité ${j + 1} : prix invalide.`);
          anyAErr = true;
        }

        if (anyAErr) {
          pErr.activities[j] = aErr;
          anyPErr = true;
        }
      });

      if (anyPErr) newErrors.profils[i] = pErr; // n’ajoute que s’il y a vraiment des erreurs
    });

    const hasAnyError =
      Object.keys(newErrors.fields).length > 0 ||
      Object.keys(newErrors.profils).length > 0 ||
      Object.keys(newErrors.meta).length > 0;

    return { newErrors, firstMsg, hasAnyError };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userId = localStorage.getItem("userId");
    if (!userId) {
      alert("Utilisateur non connecté !");
      return;
    }

    const { newErrors, firstMsg, hasAnyError } = validateAll();
    if (hasAnyError) {
      setErrors(newErrors);
      alert(`❌ ${firstMsg || "Certains champs sont invalides."}`);
      return;
    } else {
      setErrors({ fields: {}, profils: {}, meta: {} });
    }

    const { companyName, description, address, postalCode, city, numberPhone } =
      formData;

    setPendingData({
      companyName,
      description,
      address,
      postalCode,
      city,
      numberPhone,
      userId,
      annonceId,
    });

    // Démarre la vérification
    await startVerification(numberPhone);
  };

  const startVerification = async (formNumber) => {
    if (smsLoading) return;
    setSmsLoading(true);
    setSmsError("");

    const accountTelephone =
      localStorage.getItem("telephone") || localStorage.getItem("phone") || "";
    const phoneToVerify = accountTelephone || formNumber;

    try {
      const sendRes = await fetch(`${API_BASE}/api/otp/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ telephone: phoneToVerify }),
      });
      const payload = await sendRes.json().catch(() => ({}));
      if (!sendRes.ok) {
        throw new Error(payload.error || "Impossible d'envoyer le SMS.");
      }
      setPendingPhone(phoneToVerify);
      setShowVerifyPopup(true);
    } catch (err) {
      console.error(err);
      setSmsError("Erreur lors de l'envoi du code.");
    }
    setSmsLoading(false);
  };

  const handleValidateCode = async (code) => {
    if (smsLoading) return;
    setSmsLoading(true);
    setSmsError("");
    try {
      const verifyRes = await fetch(`${API_BASE}/api/otp/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ telephone: pendingPhone, code }),
      });
      const verifyData = await verifyRes.json().catch(() => ({}));
      if (
        !verifyRes.ok ||
        !verifyData ||
        verifyData.message !== "Numéro vérifié avec succès."
      ) {
        setSmsError(verifyData?.error || "Code incorrect.");
      } else {
        setShowVerifyPopup(false);
        await finishSubmit();
      }
    } catch (err) {
      console.error(err);
      setSmsError("Erreur lors de la vérification.");
    }
    setSmsLoading(false);
  };

  const finishSubmit = async () => {
    if (!pendingData) {
      alert("❌ Données manquantes, veuillez réessayer.");
      return;
    }
    try {
      const data = new FormData();
      data.append("nameCompany", pendingData.companyName);
      data.append("description", pendingData.description);
      data.append("adresCompany", pendingData.address);
      data.append("postalCode", pendingData.postalCode);
      data.append("city", pendingData.city);
      data.append("phoneNumber", pendingData.numberPhone);
      data.append("userId", pendingData.userId);
      data.append("profils", JSON.stringify(profils));

      if (image) {
        data.append("image", image);
      } else if (existingImageName) {
        data.append("existingImage", existingImageName);
      }

      if (coordinates) {
        data.append("coordinates", JSON.stringify(coordinates));
      }

      let response;
      if (annonceId) {
        response = await fetch(`${API_BASE}/api/annonces/${annonceId}`, {
          method: "PUT",
          credentials: "include",
          body: data,
        });
      } else {
        response = await fetch(`${API_BASE}/api/annonces`, {
          method: "POST",
          credentials: "include",
          body: data,
        });
      }

      if (!response.ok) throw new Error("Erreur lors de l'enregistrement");

      const result = await response.json();
      alert(annonceId ? "✅ Annonce mise à jour !" : "✅ Annonce enregistrée !");
      if (result._id) {
        navigate(`/editAnnonce/${result._id}`);
      } else {
        alert("❌ Erreur : ID manquant après création.");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Erreur lors de l'enregistrement");
    }
  };

  // Publier
  const handlePublier = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/annonces/${annonceId}/publier`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      if (!res.ok) throw new Error("Erreur lors de la publication.");
      alert("✅ Annonce publiée !");
      window.location.reload();
    } catch (e) {
      alert("Erreur lors de la publication !");
    }
  };

  return (
    <>
      <VerifyPhonePopup
        visible={showVerifyPopup}
        phoneNumber={pendingPhone}
        onCancel={() => setShowVerifyPopup(false)}
        onValidate={handleValidateCode}
        onResend={() => startVerification(pendingPhone)}
        loading={smsLoading}
        error={smsError}
      />

      {/* --- Statut et commentaire admin --- */}
      {statut && (
        <div
          style={{
            marginBottom: 20,
            padding: 14,
            borderRadius: 12,
            background: "#f5e8e0",
            color: "#b26a57",
            fontWeight: 600,
          }}
        >
          Statut de l'annonce:{" "}
          <span style={{ textTransform: "capitalize" }}>
            {statut.replace("_", " ")}
          </span>
          {statut === "refuse" && commentaireAdmin && (
            <div style={{ color: "#b21c1c", marginTop: 8 }}>
              <strong>Motif du refus :</strong> {commentaireAdmin}
            </div>
          )}
          {statut === "valide" && (
            <div style={{ color: "#237b1b", marginTop: 8 }}>
              ✅ Votre annonce est validée par l'administration, vous pouvez la
              publier !
            </div>
          )}
          {statut === "publiee" && (
            <div style={{ color: "#2563eb", marginTop: 8 }}>
              🎉 Votre annonce est en ligne !
            </div>
          )}
          {statut === "en_attente" && (
            <div style={{ color: "#c88924", marginTop: 8 }}>
              ⏳ Votre annonce est en attente de validation.
            </div>
          )}
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="annonce-form"
        encType="multipart/form-data"
      >
        <h2 className="annonce-title">
          {annonceId ? "Modifier mon annonce" : "Poster mon annonce (entreprise)"}
        </h2>

        <input
          type="text"
          placeholder="Nom de votre entreprise"
          value={formData.companyName}
          onChange={(e) =>
            setFormData({ ...formData, companyName: e.target.value })
          }
          className="annonce-input"
          style={errStyle(errors.fields.companyName)}
        />
        {smallErr(errors.fields.companyName)}

        <textarea
          placeholder="Présentez brièvement votre entreprise"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          className="annonce-textarea"
          style={errStyle(errors.fields.description)}
        />
        {smallErr(errors.fields.description)}

        <AdresseAutocomplete
          value={formData.address}
          onChange={handleAddressChange}
          onSelect={handleAddressSelect}
        />
        {smallErr(errors.fields.address)}

        <input
          type="text"
          placeholder="Code postal"
          value={formData.postalCode}
          onChange={(e) =>
            setFormData({ ...formData, postalCode: e.target.value })
          }
          className="annonce-input"
          style={errStyle(errors.fields.postalCode)}
        />
        {smallErr(errors.fields.postalCode)}

        <input
          type="text"
          placeholder="Ville"
          value={formData.city}
          onChange={(e) => setFormData({ ...formData, city: e.target.value })}
          className="annonce-input"
        />

        <input
          type="text"
          placeholder="Numéro de téléphone"
          value={formData.numberPhone}
          onChange={(e) =>
            setFormData({ ...formData, numberPhone: e.target.value })
          }
          className="annonce-input"
          style={errStyle(errors.fields.numberPhone)}
        />
        {smallErr(errors.fields.numberPhone)}

        <label
          htmlFor="logo-upload"
          className="annonce-input"
          style={{
            cursor: "pointer",
            padding: "16px",
            background: "#edf2ff",
            borderRadius: "15px",
            marginBottom: 15,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            fontWeight: 500,
            fontSize: 17,
            textAlign: "center",
          }}
        >
          <span style={{ fontSize: 22, fontWeight: "bold", color: "#6c6bc6" }}>
            +
          </span>
          <span>
            {image
              ? image.name
              : existingImageName || "Appuyer pour ajouter votre logo"}
          </span>
          <input
            id="logo-upload"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleImageChange}
          />
        </label>

        <h3 className="annonce-subtitle" style={{ marginTop: 40 }}>
          Ajouter un ou plusieurs profils professionnels
        </h3>
        <p style={{ color: "#7e5e47", fontSize: 15, marginBottom: 8 }}>
          Chaque profil gère sa profession, ses activités et ses horaires
          (collaborateur, équipe, etc).
        </p>
        {smallErr(errors.meta.noProfil)}

        {profils.map((profil, idx) => {
          const lib = mergeActivityLibrary(profil.profession);
          const dataListId = `actlib-${idx}`;
          const pErr = errors.profils[idx] || { activities: {} };

          return (
            <div
              key={idx}
              className="activity-row"
              style={{ border: "2px dashed #a68b76" }}
            >
              <input
                type="text"
                placeholder="Nom du profil (employé ou vous-même)"
                value={profil.name}
                onChange={(e) =>
                  handleProfilFieldChange(idx, "name", e.target.value)
                }
                className="annonce-input"
                style={errStyle(pErr.name)}
              />
              {smallErr(pErr.name)}

              <select
                className="annonce-input"
                value={profil.profession}
                onChange={(e) =>
                  handleProfilProfessionChange(idx, e.target.value)
                }
                style={errStyle(pErr.profession)}
              >
                <option value="">Sélectionnez une profession</option>
                {PROFESSION_LIST.map((profession) => (
                  <option key={profession} value={profession}>
                    {profession}
                  </option>
                ))}
              </select>
              {smallErr(pErr.profession)}

              {/* Ajout rapide depuis bibliothèque */}
              {profil.profession && (
                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    marginBottom: 12,
                    flexWrap: "wrap",
                  }}
                >
                  <select
                    className="annonce-input"
                    style={{ flex: "1 1 320px" }}
                    defaultValue=""
                    onChange={(e) => {
                      handleAddActivityFromLibrary(idx, e.target.value);
                      e.target.value = "";
                    }}
                  >
                    <option value="">
                      ➕ Ajouter une activité (suggestions + catalogue communautaire —{" "}
                      {profil.profession})
                    </option>
                    {lib.map((a) => (
                      <option key={a.name} value={a.name}>
                        {a.name}
                      </option>
                    ))}
                  </select>
                  <span style={{ fontSize: 13, color: "#7e5e47" }}>
                    (modifiable après ajout)
                  </span>
                </div>
              )}

              <div style={{ marginBottom: 10 }}>
                <strong>Horaires du profil</strong>
                <div className="profil-hours-list">
                  {profil.workingHours.map((day, dIdx) => (
                    <div
                      key={day.day}
                      className="profil-hours-day"
                      style={{ marginBottom: 12 }}
                    >
                      <span style={{ fontWeight: 600 }}>{day.day}</span>

                      <label className="radio-label" style={{ marginLeft: 12 }}>
                        <input
                          type="radio"
                          name={`isOpen-${idx}-${dIdx}`}
                          value="true"
                          checked={day.isOpen === true}
                          onChange={(e) =>
                            handleProfilWorkingHourChange(
                              idx,
                              dIdx,
                              "isOpen",
                              e.target.value
                            )
                          }
                        />{" "}
                        Ouvert
                      </label>

                      <label className="radio-label" style={{ marginLeft: 8 }}>
                        <input
                          type="radio"
                          name={`isOpen-${idx}-${dIdx}`}
                          value="false"
                          checked={day.isOpen === false}
                          onChange={(e) =>
                            handleProfilWorkingHourChange(
                              idx,
                              dIdx,
                              "isOpen",
                              e.target.value
                            )
                          }
                        />{" "}
                        Fermé
                      </label>

                      {day.isOpen && (
                        <div style={{ marginTop: 6, width: "100%" }}>
                          {day.slots.map((slot, slotIdx) => (
                            <div key={slotIdx} className="profil-hours-slot">
                              <input
                                type="time"
                                value={slot.start}
                                onChange={(e) =>
                                  handleSlotChange(
                                    idx,
                                    dIdx,
                                    slotIdx,
                                    "start",
                                    e.target.value
                                  )
                                }
                              />
                              <input
                                type="time"
                                value={slot.end}
                                onChange={(e) =>
                                  handleSlotChange(
                                    idx,
                                    dIdx,
                                    slotIdx,
                                    "end",
                                    e.target.value
                                  )
                                }
                              />
                              {day.slots.length > 1 && (
                                <button
                                  type="button"
                                  className="delete-button"
                                  onClick={() =>
                                    handleDeleteSlot(idx, dIdx, slotIdx)
                                  }
                                >
                                  Supprimer plage
                                </button>
                              )}
                            </div>
                          ))}

                          <button
                            type="button"
                            className="add-button"
                            onClick={() => handleAddSlot(idx, dIdx)}
                          >
                            ➕ Ajouter une plage horaire
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <strong>Activités du profil</strong>
                {smallErr(pErr.activitiesEmpty)}
                <p
                  style={{
                    color: "#7e5e47",
                    margin: "6px 0 10px 0",
                    fontSize: 14,
                  }}
                >
                  💡 Saisissez librement une activité si elle n’apparaît pas : elle
                  est enregistrée sur votre annonce puis <strong>vérifiée</strong>{" "}
                  par l’équipe. Une fois l’annonce prise en compte, le libellé est{" "}
                  <strong>ajouté au catalogue</strong> de la même profession pour
                  aider les pros suivants (tri par popularité).
                </p>
                <div className="profile-activities-list">
                  {profil.activities.map((activity, aIdx) => {
                    const aErr = (pErr.activities || {})[aIdx] || {};
                    return (
                      <div key={aIdx} className="profile-activity-line">
                        <input
                          type="text"
                          placeholder="Nom précis de l'activité"
                          value={activity.name}
                          onChange={(e) =>
                            handleProfilActivityChange(
                              idx,
                              aIdx,
                              "name",
                              e.target.value
                            )
                          }
                          list={dataListId}
                          style={errStyle(aErr.name)}
                        />
                        {smallErr(aErr.name)}
                        <datalist id={dataListId}>
                          {(lib || []).map((a) => (
                            <option key={a.name} value={a.name} />
                          ))}
                        </datalist>

                        <div
                          className="activity-duration"
                          style={{ display: "flex", gap: 12 }}
                        >
                          <div
                            className="duration-field"
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <label
                              htmlFor={`h-${idx}-${aIdx}`}
                              style={{ fontSize: 12, color: "#7e5e47" }}
                            >
                              Heures
                            </label>
                            <input
                              id={`h-${idx}-${aIdx}`}
                              type="number"
                              min={0}
                              value={activity.durationHours || 0}
                              onChange={(e) =>
                                handleProfilActivityChange(
                                  idx,
                                  aIdx,
                                  "durationHours",
                                  e.target.value
                                )
                              }
                              style={errStyle(aErr.durationHours)}
                            />
                            {smallErr(aErr.durationHours)}
                          </div>

                          <div
                            className="duration-field"
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <label
                              htmlFor={`m-${idx}-${aIdx}`}
                              style={{ fontSize: 12, color: "#7e5e47" }}
                            >
                              Minutes
                            </label>
                            <input
                              id={`m-${idx}-${aIdx}`}
                              type="number"
                              min={0}
                              max={59}
                              value={activity.durationMinutes || 0}
                              onChange={(e) =>
                                handleProfilActivityChange(
                                  idx,
                                  aIdx,
                                  "durationMinutes",
                                  e.target.value
                                )
                              }
                              style={errStyle(aErr.durationMinutes)}
                            />
                            {smallErr(aErr.durationMinutes)}
                          </div>
                        </div>

                        <input
                          type="number"
                          placeholder="Prix (€)"
                          value={activity.price === "" ? "" : Number(activity.price)}
                          onChange={(e) =>
                            handleProfilActivityChange(
                              idx,
                              aIdx,
                              "price",
                              e.target.value
                            )
                          }
                          min={0}
                          step="0.01"
                          style={errStyle(aErr.price)}
                        />
                        {smallErr(aErr.price)}

                        <button
                          type="button"
                          className="delete-button"
                          onClick={() => handleProfilDeleteActivity(idx, aIdx)}
                        >
                          Supprimer activité
                        </button>
                      </div>
                    );
                  })}
                </div>

                <button
                  type="button"
                  className="add-button"
                  onClick={() => handleProfilAddActivity(idx)}
                >
                  Ajouter une activité
                </button>

                <button
                  type="button"
                  className="delete-button"
                  style={{ marginTop: 16 }}
                  onClick={() => handleDeleteProfil(idx)}
                >
                  Supprimer ce profil
                </button>
              </div>

              <div style={{ marginTop: 18 }}>
                <strong>
                  Créneaux (disponibilités) du profil (générés automatiquement)
                </strong>
                <div
                  style={{
                    maxHeight: 200,
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    padding: 8,
                    borderRadius: 8,
                    backgroundColor: "#fafafa",
                    fontSize: 14,
                    color: "#555",
                  }}
                >
                  {getGeneratedSlots(profil).length > 0 ? (
                    getGeneratedSlots(profil).map((slotStr, sIdx) => (
                      <div key={sIdx} style={{ marginBottom: 4 }}>
                        {slotStr}
                      </div>
                    ))
                  ) : (
                    <div style={{ color: "#888" }}>Aucun créneau généré</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}

        <button
          type="button"
          className="add-button"
          style={{ marginTop: 10, fontWeight: 700 }}
          onClick={handleAddProfil}
          disabled={smsLoading || profils.length >= maxProfils}
        >
          ➕ Ajouter un profil professionnel
        </button>

        {profils.length >= maxProfils && (
          <div
            style={{
              color: "#c81b1b",
              fontWeight: 500,
              marginTop: 6,
              marginBottom: 12,
            }}
          >
            {abonnement === "premium"
              ? "Vous pouvez ajouter jusqu’à 5 profils avec l’abonnement Premium."
              : "Votre abonnement ne permet d’ajouter qu’un seul profil."}
          </div>
        )}

        <button type="submit" className="submit-button" disabled={smsLoading}>
          {annonceId ? "Mettre à jour l'annonce" : "Enregistrer l'annonce"}
        </button>

        {statut === "valide" && (
          <button
            type="button"
            className="submit-button"
            style={{ background: "#2563eb", marginTop: 12 }}
            onClick={handlePublier}
          >
            Publier mon annonce
          </button>
        )}
      </form>
    </>
  );
};

export default AnnonceForm;
